<ui-tab-group class="hidden md:block">
  <a
    routerLink="./general"
    routerLinkActive
    #general="routerLinkActive"
    [attr.aria-current]="general.isActive"
  >
    <ui-tab [active]="general.isActive">
      <h2 class="flex">
        <ng-icon name="heroInformationCircle" size="20" class="!block mr-2" />
        {{ 'cockpit.supplierContracts.detailsPage.navGeneral' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./price"
    routerLinkActive
    #price="routerLinkActive"
    [attr.aria-current]="price.isActive"
  >
    <ui-tab [active]="price.isActive">
      <h2 class="flex">
        <ng-icon name="heroCurrencyEuro" size="20" class="!block mr-2" />
        {{ 'cockpit.supplierContracts.detailsPage.navPrice' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./admin-edit"
    routerLinkActive
    #adminEdit="routerLinkActive"
    [attr.aria-current]="adminEdit.isActive"
    *hasRole="'USER_ADMIN'"
  >
    <ui-tab [active]="adminEdit.isActive">
      <h2 class="flex text-admin dark:text-admin-darkmode">
        <ng-icon name="heroPencilSquare" size="20" class="!block mr-2" />
        {{ 'cockpit.supplierContracts.detailsPage.navAdminEdit' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./check"
    routerLinkActive
    #check="routerLinkActive"
    [attr.aria-current]="check.isActive"
  >
    <ui-tab [active]="check.isActive">
      <h2 class="flex gap-2 h-5">
        <ng-icon name="heroLightBulb" size="20" class="!block" />
        {{ 'cockpit.supplierContracts.detailsPage.navCheck' | transloco }}
        @if (contractCheckAlerts() > 0) {
          <ui-badge [iconOnly]="true" rounded="full" color="error" mode="filled">
            {{ contractCheckAlerts() }}
          </ui-badge>
        }
      </h2>
    </ui-tab>
  </a>
</ui-tab-group>
<div class="md:hidden">
  <ui-select (selectChange)="onSelectChange($event)">
    <option
      routerLink="./general"
      routerLinkActive
      #generalMobile="routerLinkActive"
      value="./general"
      [selected]="generalMobile.isActive"
    >
      {{ 'cockpit.supplierContracts.detailsPage.navGeneral' | transloco }}
    </option>
    <option
      routerLink="./price"
      routerLinkActive
      #priceMobile="routerLinkActive"
      value="./price"
      [selected]="priceMobile.isActive"
    >
      {{ 'cockpit.supplierContracts.detailsPage.navPrice' | transloco }}
    </option>
    <option
      routerLink="./admin-edit"
      routerLinkActive
      #adminEditMobile="routerLinkActive"
      value="./admin-edit"
      [selected]="adminEditMobile.isActive"
      *hasRole="'USER_ADMIN'"
    >
      {{ 'cockpit.supplierContracts.detailsPage.navAdminEdit' | transloco }}
    </option>
    <option
      routerLink="./check"
      routerLinkActive
      #checkMobile="routerLinkActive"
      value="./check"
      [selected]="checkMobile.isActive"
    >
      {{ 'cockpit.supplierContracts.detailsPage.navCheck' | transloco }}
    </option>
  </ui-select>
</div>
